import React from 'react';
import ReportTable from "../../hoc/ReportTable/ReportTable";
import { ReportSectionHeader } from "../../common/components/SectionHeader";



const ClassFloatAverages = (props) => (
    <div>
        <ReportSectionHeader>
        {props.isDandO === "true"?"Evaluation Period Effective Float Summary Statistics" :
        "Class Period Effective Float Summary Statistics"
    	}
        </ReportSectionHeader>
        <ReportTable
            settings={[
                {
                    header: '', accessor: 'name',
                    map: {
                        classPeriodAveSO: "Shares outstanding (+)",
                        classPeriodAveSI: "Short Interest (+)",
                        classPeriodAveIH: "Insider Holdings (-) ",
                        classPeriodAveFloat: "Average Effective Float",
                    }
                },
                {
                    header: 'Average Shares of Common Stock',
                    accessor: 'classFloatAverages',
                    dollarValue: false,
                    inThousands: false,
                    formatNumberWithCommas: true,
                    truncateDecimal: true,
                },
            ]}
            data={props.classFloatAverages}
            name={"classFloatAverages"}
            isNotApplicable={'Yes'}
            accumulatorDisplay={'Class Period Average Float'}
        />
    </div>
);


export default ClassFloatAverages;


// WEBPACK FOOTER //
// ./src/components/ClassFloatAverages/classFloatAverages.js